const initialState = {
  fetched: false,
  data: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case 'SAVINGS_MODULE_FETCHED':
      if (action.payload) {
        return Object.assign({}, state, { fetched: true, data: action.payload });
      } else {
        return Object.assign({}, state, { fetched: true, data: null });
      }
    case 'EDIT_SAVINGS_MODULE':
      return Object.assign({}, state, {
        ...state,
        data: {
          ...state.data,
          [action.key]: action.value,
        },
      });
    default:
      return state;
  }
}
